<template>
  <base-card
    v-if="EntityCardMixin_CopySource"
    :title="EntityCardMixin_Title"
  >
    <v-row>
      <template
        v-if="EntityCardMixin_Picker"
      >
        <base-picker
          v-if="entityCardMixin.pickers.components[0]"
          v-model="entityCardMixin.pickers.components[0]"
          base-field-container-type="v-col"
          :items="monitors"
          :label="TextMixin_GetLabel('monitor')"
          :rules="pickers[0].rules"
          @pickers-create="$emit('pickers-create', $event)"
          @pickers-read="$emit('pickers-read', $event)"
          @pickers-update="$emit('pickers-update', $event)"
        />
      </template>
      <template
        v-if="EntityCardMixin_CopySource"
      >
        <base-field
          v-if="!EntityCardMixin_Picker && EntityCardMixin_CopySource.firstName"
          v-model="EntityCardMixin_CopySource.firstName"
          base-field-container-type="v-col"
          :disabled="EntityCardMixin_Disabled"
          :label="TextMixin_GetLabel('firstName')"
          :readonly="EntityCardMixin_Readonly"
          :rules="[validationMixin.rules.charactersMax(EntityCardMixin_CopySource.firstName.value, 255)]"
        />
        <base-field
          v-if="!EntityCardMixin_Picker && EntityCardMixin_CopySource.lastName"
          v-model="EntityCardMixin_CopySource.lastName"
          base-field-container-type="v-col"
          :disabled="EntityCardMixin_Disabled"
          :label="TextMixin_GetLabel('lastName')"
          :readonly="EntityCardMixin_Readonly"
          :rules="[validationMixin.rules.charactersMax(EntityCardMixin_CopySource.lastName.value, 255)]"
        />
      </template>
    </v-row>
  </base-card>
</template>

<script>
import EntityCardMixin from '@/mixins/entity-card-mixin'

export default {
  name: 'EntityCardMonitorsDetailGeneralInformation',
  mixins: [
    EntityCardMixin
  ],
  mounted () {
    this.Initialize()
  },
  methods: {
    Initialize () {
      this.EntityCardMixin_SetDefaultTitle('generalInformation')
    }
  }
}
</script>
